import script from "./OTabelaProjetos.vue?vue&type=script&lang=ts&setup=true"
export * from "./OTabelaProjetos.vue?vue&type=script&lang=ts&setup=true"

import "./OTabelaProjetos.vue?vue&type=style&index=0&id=691c192f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-691c192f"]])

export default __exports__